import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import {
    getAnalytics,
} from "../Redux/Actions/auth";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import FeedbackSummary from "../Components/FeedbackSummary";

export default function Dashboard() {
    const analytics = useSelector((e) => e.userAuth.analyticsData);
    const dispatch = useDispatch()

    const Inialize = () => {
        try {
            dispatch(startstopLoading(true));
            dispatch(getAnalytics()).then((res) => {
                dispatch(startstopLoading(false));
            });
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        Inialize();
    }, []);

    return (
        <Layout>
            <Container fluid>
                <div className="filters">
                    <div className="inner-filter-field">
                        <div className="image-heading-text">
                            <h2>Analytics</h2>
                        </div>

                        <div className="mneu-cards-contin">
                            <div className="mneu-cards-item">
                                <h2>Total sessions</h2>
                                {/* <p>-</p> */}
                                <p>{analytics?.totalSessions}</p>
                            </div>
                            <div className="mneu-cards-item">
                                <h2>Average Conversation length</h2>
                                {/* <p>-</p> */}
                                <p>{analytics?.averageSessionDuration}</p>
                            </div>
                            <div className="mneu-cards-item">
                                <h2>Total Conversations</h2>
                                <p>{analytics?.totalConversations}</p>
                            </div>
                            <div className="mneu-cards-item">
                                <h2>Most used chatbot</h2>
                                {/* <p>-</p> */}
                                <p>{analytics?.getChatBotDetails?.name}</p>
                            </div>
                        </div>
                        <div className="user-search">

                        </div>

                        <div className="mb-4" >
                            <FeedbackSummary />
                        </div>

                        <div >
                            <p className="ms-2" >Top 10 frequently asked questions</p>
                        </div>

                        <div class="table-responsive">
                            <Table size="sm" className="table-cmn">
                                <thead>
                                    <tr>
                                        <th>Sr.No.</th>
                                        <th>Question</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {analytics?.topQuestion?.map((res, index) =>
                                        <tr key={index}>
                                            <td>
                                                <div className="first-user">
                                                    <div className="user-id">
                                                        <p>{index + 1}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="first-user">
                                                    <div className="user-id">
                                                        <p>{res._id}</p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}

                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                <div className="made-with">
                    <div className="pixinvent">
                        <p>
                            {" "}
                            © {new Date().getFullYear()}, Made with ❤️ by <span>Codobux</span>
                        </p>
                    </div>
                </div>
            </Container>
        </Layout>
    );
}
